var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinMapBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 38.6667C20 38.6667 35 28.6667 35 17C35 13.0218 33.4196 9.20644 30.6066 6.3934C27.7936 3.58035 23.9782 2 20 2C16.0218 2 12.2064 3.58035 9.3934 6.3934C6.58035 9.20644 5 13.0218 5 17C5 28.6667 20 38.6667 20 38.6667Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.1667L14.75 15.25V21.6667C14.75 21.9761 14.8729 22.2728 15.0917 22.4916C15.3105 22.7104 15.6072 22.8333 15.9167 22.8333H24.0833C24.3928 22.8333 24.6895 22.7104 24.9083 22.4916C25.1271 22.2728 25.25 21.9761 25.25 21.6667V15.25L20 11.1667Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 17,
    width: 4,
    height: 6,
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMapBlack);
export default __webpack_public_path__ + "static/media/pin-map-black.e7e4d2e931bf1e4c15ef9b80fc33b24b.svg";
export { ForwardRef as ReactComponent };